function mathHeight(ul,grid,title,dg,mg){  
  var gridWrap = document.getElementsByClassName(ul)[0];
  if(typeof gridWrap != 'undefined'){
    var els = gridWrap.getElementsByClassName(grid);
    var initialStart = 0;
    var defaultHeight = 0;
    var totalGridCount = els.length - 1;
    var grid__count = 0;
    for(var i = 0; i < els.length; i++){
      initialStart = initialStart + 1; 
      if (els[i].getElementsByClassName(title)[0] != undefined ){
        var currentHeight = els[i].getElementsByClassName(title)[0].offsetHeight;  
      }
      if(currentHeight > defaultHeight){
        defaultHeight = currentHeight;
      }
      var gridCount = dg;
      var gridCountMinus = dg - 1;
      
      var screencWidth = document.documentElement.clientWidth;
      if(screencWidth < 769){
        var gridCount = mg;
        var gridCountMinus = mg - 1;
      }
      if(initialStart == gridCount || totalGridCount == i){
        var startIndex = grid__count;
        
        for(var j=startIndex; j<=i; j++){
          if(els[j]){
            if (els[j].getElementsByClassName(title)[0] != undefined ){
              els[j].getElementsByClassName(title)[0].style.minHeight = defaultHeight+'px';
                grid__count = grid__count + 1;
            }
          }
        }
        initialStart = 0;
        defaultHeight = 0;
      }
    }
  }
}

$('.main_thumbnail-list').flickity({
  asNavFor: ".main_product__media-list", 
  contain : true,
  pageDots: false, 
  lazyLoad: true,
  resize: true,
  setGallerySize: false,
  prevNextButtons: true
});

$('.main_product__media-list').flickity({
  sync: ".main_thumbnail-list",
  prevNextButtons: false,
  pageDots: true
});

$('.product-slider-list').flickity({
  contain : true,
  pageDots: true, 
  lazyLoad: true,
  freeScroll: true,
  prevNextButtons: true,
  groupCells: 3,
  groupCells: true
});

$('.main_product__media-list').on( 'change.flickity', function( index ) {
    var currentSlide = document.querySelector(".product__media-item.is-selected");
    var data_count =  currentSlide.getAttribute("data-count");
    document.querySelector(".swiper-custom-pagination").innerHTML  = data_count;
});
$('.main_thumbnail-list').on( 'change.flickity', function( thumbIndex ) {
  var allThumbnail = document.querySelectorAll('.thumbnail-list__item');
  var currThumb = Number(document.querySelector('.thumbnail-list__item.is-selected').getAttribute('data-index'));
  var secondThumb = allThumbnail[1].getAttribute('data-index');
  var lastThumb = document.querySelector('.main_thumbnail-list').querySelector('.flickity-slider');
  if(allThumbnail.length > 6 ){
    if( allThumbnail.length-2 == currThumb ){    
      lastThumb.style.left = '-74' + 'px';
    }
    else if(secondThumb == currThumb ){
      lastThumb.style.left = '76' + 'px';
    }
  }
});
document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector('.main_thumbnail-list') != null ){
    var thumbList = document.querySelectorAll('.thumbnail-list__item');
    if(thumbList.length > 6 ){
      var topThumb = document.querySelector('.main_thumbnail-list').querySelector('.flickity-slider');  
      topThumb.style.left = '76' + 'px';
    }
  }
});
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {  
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id') != null ) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if(summary.closest('details') != null){
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if(elementToFocus != null){
    elementToFocus.focus();
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
// // remove emplt alt tags
// $('img').each(function(){
//     // Check if alt attribute exists and if it's empty
//     if ($(this).attr('alt') === '') {
//         $(this).removeAttr('alt'); // Remove alt attribute if it's empty
//     }
// });
// sub menu focus 
var isBack = false;
var elements = document.querySelectorAll('.site-nav__link');
elements.forEach(function(element, index) {
  var parentWithClass = element.closest('.site-nav__item');
  element.addEventListener('focus', function() {
    parentWithClass.classList.add("hover");
  });
 
    var buttons = parentWithClass.querySelectorAll('button.quick-add__submit');
    var lastButton = buttons[buttons.length-1];
    lastButton.addEventListener('focusout', function() {
      var parentClass = lastButton.closest('.site-nav__item');
      parentClass.classList.remove("hover");
    });
});
var headermenus = document.querySelectorAll("summary.header__menu-item.list-menu__item.link.focus-inset");
headermenus.forEach(function(menu,index){
  var parent = menu.closest('li');
  var submenu = parent.querySelector("ul.header__submenu");
  parent.addEventListener('focus', function() {
    closeAllMenus();
    if (submenu) {
      submenu.style.display = 'block';
    }
  });
  parent.addEventListener('mouseover', function() {
    closeAllMenus();
  });
  var buttons = submenu.querySelectorAll("li");
  var lastButton = buttons[buttons.length-1];
  lastButton.addEventListener('focusout', function() {
    if(!isBack)
    {
      submenu.style.display='';
    }
  });
});
function closeAllMenus() {
  var openMenus = document.querySelectorAll("ul.header__submenu");
  openMenus.forEach(function (menu) {
    menu.style.display = '';
  });
}
document.addEventListener('keyup', function(event) {
    var variantInputs = document.querySelectorAll('.variant-input input');

  // Attach event listeners to each variant input
  variantInputs.forEach(function(input) {
    input.addEventListener('focus', function() {
      // Highlight the variant selection area when the input is in focus
      var variantMainWrap = input.closest('.variant-main-wrap');
      variantMainWrap.style.border = '2px solid #204f84';
      variantMainWrap.style.padding = '10px';
      variantMainWrap.style.float = 'left';
    });
  
    input.addEventListener('blur', function() {
      // Remove the highlight when the input loses focus
      var variantMainWrap = input.closest('.variant-main-wrap');
      variantMainWrap.style.border = 'none';
      variantMainWrap.style.padding = '0';
    });
  });
});

document.addEventListener('keydown', function(event) {
  isBack=false;
  if (event.shiftKey && event.key === 'Tab') 
  {
    isBack=true;
    if(document.activeElement.querySelector("ul.header__submenu"))
    {
      document.activeElement.querySelector("ul.header__submenu").style.display='';
    }
    if(document.activeElement.classList.contains('site-nav__link'))
    {
        var ele = document.activeElement.closest('.site-nav__item');
        if(ele)
        {
          ele.classList.remove("hover");
        }
    }
  }
  if (event.key === 'Escape') {
    var menus = document.querySelectorAll('.site-nav__item'); // Replace with your menu's class
    for(let i =0;i<menus.length;i++)
      {
          if (menus[i].classList.contains('hover')) {
          menus[i].classList.remove('hover');
          if(i!=menus.length-1)
          {
            var el = menus[i+1].querySelector('.site-nav__link');
            if(el) el.focus();
          }
          return;
        }
      }
      var headersubmenus = document.querySelectorAll("ul.header__submenu");
      for(let i =0;i<headersubmenus.length;i++)
      {
          const computedStyle = window.getComputedStyle(headersubmenus[i]);
        if (computedStyle.getPropertyValue('display') === 'block') {
          headersubmenus[i].style.display='';
          if(i!=headersubmenus.length-1)
          {
            headersubmenus[i+1].closest('li').focus();
          }
          return;
        }
      }
  }
  if (event.key === 'Enter') {
    const element = document.activeElement.querySelector('.course-accordion');
    if (element.classList.contains('course-accordion')) {
      element.click();
    }
  }
});
function closeSubmenu() {
  var menus = document.querySelectorAll('.site-nav__item'); // Replace with your menu's class
    for(let i =0;i<menus.length;i++)
      {
          if (menus[i].classList.contains('hover')) {
          menus[i].classList.remove('hover');
          if(i!=menus.length-1)
          {
            var el = menus[i+1].querySelector('.site-nav__link');
            if(el) el.focus();
          }
          return;
        }
      }
}
document.addEventListener('click', function (event) {
  var menus = document.querySelectorAll('.site-nav__item');
  menus.forEach(function(menu,index){
    if (!menu.contains(event.target)) {
    closeSubmenu();
  }
  });
  var headermenu = document.querySelector('ul.list-menu.list-menu--inline');
  if (!headermenu.contains(event.target)) {
    var headersubmenus = document.querySelectorAll("ul.header__submenu");
      for(let i =0;i<headersubmenus.length;i++)
      {
          const computedStyle = window.getComputedStyle(headersubmenus[i]);
        if (computedStyle.getPropertyValue('display') === 'block') {
          headersubmenus[i].style.display='';
          return;
        }
      }
  }
});
//Image focus on our team page
document.addEventListener('DOMContentLoaded', function () {
  var teamImages = document.querySelectorAll('.our-teammate .team-image');

  teamImages.forEach(function (teamImage) {
    teamImage.addEventListener('focus', function () {
      this.querySelector('figure img').style.filter = 'grayscale(0)';
    });

    teamImage.addEventListener('blur', function () {
      this.querySelector('figure img').style.filter = '';
    });

    teamImage.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        // Toggle the 'active' class on team-image
        this.classList.toggle('active');
        teamImages.forEach(function (otherTeamImage) {
          if (otherTeamImage !== teamImage) {
            otherTeamImage.classList.remove('active');
          }
        });
      }
    });
  });
});
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

//scroller for comparison section
const scrollContainer = document.querySelector(".pricing-table");
        let isDown = false;
        let startX;
        let scrollLeft;
        if(scrollContainer)
        {
          scrollContainer.addEventListener("mousedown", (e) => {
              isDown = true;
              scrollContainer.classList.add("active");
              startX = e.pageX - scrollContainer.offsetLeft;
              scrollLeft = scrollContainer.scrollLeft;
          });
  
          scrollContainer.addEventListener("mouseleave", () => {
              isDown = false;
          });
  
          scrollContainer.addEventListener("mouseup", () => {
              isDown = false;
          });
  
          scrollContainer.addEventListener("mousemove", (e) => {
              if (!isDown) return;
              e.preventDefault();
              const x = e.pageX - scrollContainer.offsetLeft;
              const walk = (x - startX) * 2; // Adjust scroll speed
              scrollContainer.scrollLeft = scrollLeft - walk;
          });
        }

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');    
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if(this.closest('.product-form__quantity') != null ){
      var currentInput = this.input.value;
      var initialPrice = this.closest('.product-form__quantity').querySelector('.subtotal .sub-price');
      var newPrice = initialPrice.getAttribute('data-price');
      
      var finalPrice = newPrice * currentInput; 
      this.closest('.product-form__quantity').querySelector('.subtotal .price-item--regular').innerHTML = Shopify.formatMoney(finalPrice); 
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    // if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;   
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');   
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;    
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length > 1) {
        if (this.sliderItemsToShow.length < 4) {
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = 1;
        this.update();
          return;}
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
const removePriceRange = function() {
const element = document.getElementById('price_range');
    if (element) {
      element.remove();
    }
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    removePriceRange();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      var checkQuickadd = document.querySelector('.quick-add-modal fieldset');
      if(checkQuickadd == null){
        this.updateMedia();
      }
      
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();   
    }     
      
    if(this.currentVariant != undefined){
    var curr_variant = this.currentVariant.sku;        
      
    if ( this.currentVariant.sku != null ){
      document.querySelector('.product-sku').classList.remove('hidden');
    }else{
      document.querySelector('.product-sku').classList.add('hidden');
    }
    
    
 
     var checkQuickadd = document.querySelector('.quick-add-modal fieldset');
      if(checkQuickadd == null){
        var pro_sku = document.querySelector('.variant-sku').innerHTML = curr_variant; 
        var label = document.querySelectorAll(".variant__label-info");
      } else {
        var pro_sku = document.querySelector('.quick-add-modal .variant-sku').innerHTML = curr_variant; 
        var label = document.querySelectorAll(".quick-add-modal .variant__label-info");
      }
      
      
      for (let index = 0; index < label.length; ++index) {
        const element = label[index];
        element.innerHTML = this.currentVariant.options[index];
      }            
      
       if(this.currentVariant.compare_at_price != null){
        var new_price = Math.round(((this.currentVariant.compare_at_price - this.currentVariant.price) * 100 / this.currentVariant.compare_at_price));
        var pro_sale = document.querySelectorAll('.badge.sale');
        for (let disc = 0; disc < pro_sale.length; ++disc) {
          const ele = pro_sale[disc];
        ele.innerHTML = new_price + '%' + ' Sale';
        }  
         if(document.querySelector('.badge.sale') != null){
          document.querySelector('.badge.sale').classList.remove('hidden');
         }
      }
       else{
         if(document.querySelector('.badge.sale') != null){
          document.querySelector('.badge.sale').classList.add('hidden');
         }
      }   

      if(checkQuickadd == null){
        var quickadd = '';
      } else {
        var quickadd = '.quick-add-modal';
      }
 
      if(this.currentVariant.available == false ){
        var soldout_var = document.querySelector(quickadd+' .variant--color-swatch').classList.remove('soldout');     
      }
      else{
        if(this.currentVariant.available == false ){
          var soldout_var = document.querySelector(quickadd+' .variant--color-swatch').classList.add('soldout');     
        }
      }

    }
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    // mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);    
    //modalContent.prepend(newMediaModal);
    
    var newImage = document.querySelector('.product__thumb[data-id="' + this.currentVariant.featured_media.id + '"]');
    var thumbIndex = newImage.getAttribute("data-index");
    $('.thumbnail-list').flickity( 'select', thumbIndex );

  }
  
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);   
        
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        var checkQuickadd = document.querySelector('.quick-add-modal fieldset');
        if(checkQuickadd == null){
          document.querySelector('.subtotal .form__label').classList.remove('visibility-hidden');

          document.querySelector('.subtotal .sub-price').setAttribute('data-price',this.currentVariant.price);
          var qtyVal = document.querySelector('.product-form__quantity .quantity__input').value;
          
          var updatePrice = this.currentVariant.price * qtyVal;
          document.querySelector('.subtotal .price-item--regular').innerHTML = Shopify.formatMoney(updatePrice);
          
          if(this.currentVariant != undefined){
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          }
        } else {
            document.querySelector('.quick-add-modal .subtotal .form__label').classList.remove('visibility-hidden');

            document.querySelector('.quick-add-modal .subtotal .sub-price').setAttribute('data-price',this.currentVariant.price);
            var qtyVal = document.querySelector('.quick-add-modal .product-form__quantity .quantity__input').value;
            
            var updatePrice = this.currentVariant.price * qtyVal;
            document.querySelector('.quick-add-modal .subtotal .price-item--regular').innerHTML = Shopify.formatMoney(updatePrice);
            
            if(this.currentVariant != undefined){
              this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            }
        }
        
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;      
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);        
 
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    document.querySelector('.subtotal .form__label').classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {    

       const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
  
   
  }
}

customElements.define('variant-radios', VariantRadios);

var main_slider_inner = new Swiper(".main-slider-inner", {
  slidesPerView: "auto",
  spaceBetween: 6,
  navigation: {
    nextEl: ".main-slider-buttons .swiper-button-next",
    prevEl: ".main-slider-buttons .swiper-button-prev",
  },
  pagination: 
  {
    el: '.swiper-pagination',
    dynamicBullets: false,
    clickable: true
  },
});

var testimonial_inner = new Swiper(".testimonial-inner", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
var top_product_slider = new Swiper(".top-product-slider", {
  slidesPerView: "auto",
  noSwiping: true,
  onlyExternal: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
   breakpoints: {
    768: {
      slidesPerView: 3
    },
    992: {
      slidesPerView: 4
    },
    1300: {
      slidesPerView: 5
    }
  }
});
if(document.querySelector('.blog-product-slider') != null ){
var blog_product_slider = null;

  function initSwiper() {
    if (window.innerWidth < 768) {
      blog_product_slider = new Swiper('.blog-product-slider', {
        slidesPerView: "auto",
        pagination: 
        {
          el: '.swiper-pagination',
          dynamicBullets: false,
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      });
    } else {
      if (blog_product_slider) {
        blog_product_slider.destroy();
        document.querySelector('.blog-product-slider .swiper-wrapper').style.removeProperty('transform');
      }
    }
  }
  var timerr;

  window.addEventListener('resize', function () {
    if (timerr) {
      clearTimeout(timerr);
    }
    timerr = setTimeout(initSwiper, 200);
  });

  initSwiper();
}

var related_product_slider = new Swiper(".related-product-slider", {
  slidesPerView: "auto",
   pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".relatedcard-swiper-buttons .swiper-button-next",
    prevEl: ".relatedcard-swiper-buttons .swiper-button-prev",
  },
   breakpoints: {
    768: {
      slidesPerView: 3
    },
    992: {
      slidesPerView: 4
    },
    1300: {
      slidesPerView: 5
    }
  }
});
var frequently_product_slider = new Swiper(".frequently-product-slider", {
  slidesPerView: "auto",
   breakpoints: {
    768: {
      slidesPerView: 3,
      navigation: {
        nextEl: ".fbt-swiper-buttons .swiper-button-next",
        prevEl: ".fbt-swiper-buttons .swiper-button-prev",
      },
    },
    992: {
      slidesPerView: 4,
      navigation: {
        nextEl: ".fbt-swiper-buttons .swiper-button-next",
        prevEl: ".fbt-swiper-buttons .swiper-button-prev",
      },
    },
    1300: {
      slidesPerView: 5,
      navigation: {
        nextEl: ".fbt-swiper-buttons .swiper-button-next",
        prevEl: ".fbt-swiper-buttons .swiper-button-prev",
      },
    }
  }
});

var like_product_slider = new Swiper(".favourite-product-slider", {
  slidesPerView: "auto",
   breakpoints: {
    768: {
      slidesPerView: 3,
      navigation: {
        nextEl: ".yml-swiper-buttons .swiper-button-next",
        prevEl: ".yml-swiper-buttons .swiper-button-prev",
      },
    },
    992: {
      slidesPerView: 4,
      navigation: {
        nextEl: ".yml-swiper-buttons .swiper-button-next",
        prevEl: ".yml-swiper-buttons .swiper-button-prev",
      },
    },
    1300: {
      slidesPerView: 5,
      navigation: {
        nextEl: ".yml-swiper-buttons .swiper-button-next",
        prevEl: ".yml-swiper-buttons .swiper-button-prev",
      },
    }
  }
});

var formula_main_content = new Swiper(".formula-main-content", {
  slidesPerView: "auto",
  spaceBetween: 12,
  pagination: {
    el: ".formula-pagination.swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
      spaceBetween: 24,   
      pagination: {
        el: ".formula-pagination.swiper-pagination",
        clickable: true,
      },
    }
  }
});
var mobileWidth = document.documentElement.clientWidth;
if(mobileWidth < 768 ){
  var team_list = new Swiper(".team-list", {
    slidesPerView: "auto",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });
}

// Acrodian Faq

  var acc = document.getElementsByClassName("course-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    //when one of the buttons are clicked run this function
    acc[i].onclick = function() {
    //variables
    var panel = this.nextElementSibling;
    var coursePanel = document.getElementsByClassName("course-panel");
    var courseAccordion = document.getElementsByClassName("course-accordion");
    var courseAccordionActive = document.getElementsByClassName("course-accordion active");

    /*if pannel is already open - minimize*/
    if (panel.style.maxHeight){
      //minifies current pannel if already open
      panel.style.maxHeight = null;
            panel.style.marginTop = '0'
      //removes the 'active' class as toggle didnt work on browsers minus chrome
      this.classList.remove("active");
    } else { //pannel isnt open...
      //goes through the buttons and removes the 'active' css (+ and -)
      for (var ii = 0; ii < courseAccordionActive.length; ii++) {
        courseAccordionActive[ii].classList.remove("active");
      }
      //Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
      for (var iii = 0; iii < coursePanel.length; iii++) {
        this.classList.remove("active");
        coursePanel[iii].style.maxHeight = null;
      }
      //opens the specified pannel
      panel.style.maxHeight = panel.scrollHeight + "px";
          panel.style.marginTop = '15px'
      //adds the 'active' addition to the css.
      this.classList.add("active");
    } 
    }
  }


// claculation Tab

(function() {
  $(function() {
    var toggle;
    return toggle = new Toggle('.toggle');
  });

  this.Toggle = (function() {
    Toggle.prototype.el = null;

    Toggle.prototype.tabs = null;

    Toggle.prototype.panels = null;

    function Toggle(toggleClass) {
      this.el = $(toggleClass);
      this.tabs = this.el.find(".tab");
      this.panels = this.el.find(".panel");
      this.bind();
    }

    Toggle.prototype.show = function(index) {
      var activePanel, activeTab;
      this.tabs.removeClass('active');
      activeTab = this.tabs.get(index);
      $(activeTab).addClass('active');
      this.panels.hide();
      activePanel = this.panels.get(index);
      return $(activePanel).show();
    };

    Toggle.prototype.bind = function() {
      var _this = this;
      return this.tabs.unbind('click').bind('click', function(e) {
        return _this.show($(e.currentTarget).index());
      });
    };

    return Toggle;

  })();

}).call(this);


// claculation

function multiplyBy(){
        
  let length = document.getElementById("number1");
  let width = document.getElementById("number2");
  let thickness = document.getElementById("number3");
    
  let lengthVal = length.value , widthVal = width.value, thicknessVal =  thickness.value;
  
  if(lengthVal && widthVal && thicknessVal){
    let total = parseFloat(lengthVal) * parseFloat(width.value ) * parseFloat(thicknessVal) / 1.805     
    document.getElementById("results").value = total;
    let totals = parseFloat(lengthVal) * parseFloat(width.value ) * parseFloat(thicknessVal) / 231
      document.getElementById("resultss").value = totals;
      document.getElementById("result").value = parseFloat(lengthVal) * parseFloat(widthVal) * parseFloat(thicknessVal);
  }
    
}

function divideBy(){
  let diameter = document.getElementById("number5");
  let thickness = document.getElementById("number6");
  
  let diameterVal = diameter.value , thicknessVal = thickness.value;

  if(diameterVal && thicknessVal){
    let total = parseFloat(parseFloat(diameterVal) / 2);
    let totalsqr = parseFloat(Math.pow(total, 2));
    let totalPI = totalsqr * 3.14; 
    let finalPI = totalPI * parseFloat(thicknessVal);
    // console.log('total',total,'totalsqr',totalsqr,'totalPI',totalPI,'finalPI',finalPI);
    document.getElementById("results1").value = finalPI;
        let ouncesPI = finalPI / 1.805
    document.getElementById("resultss1").value = ouncesPI;
       let gallons2 = finalPI / 231
    document.getElementById("resultss2").value = gallons2;
   
  }
    
} 

function cardHeading () {
  if ( document.querySelectorAll(".product-card .card__heading").length > 0 ){
   var heading = document.querySelectorAll(".product-card .card__heading");
    var titleHeight = 0;
    heading.forEach( title => {    
      var matchHeight = title.clientHeight;
      if( matchHeight > titleHeight ){
        titleHeight = title.clientHeight;
      }
    }); 
    heading.forEach( divHeight => {
      divHeight.style.minHeight = titleHeight + "px";
    }); 
  }
}

document.addEventListener("DOMContentLoaded", function() {
  if ( document.getElementsByClassName('open-drawer') != null && document.getElementsByTagName('open-drawer::before')[0] != null ){
  var faqContainers = document.getElementsByClassName('open-drawer');
  var faqToggle = document.getElementsByTagName('open-drawer::before')[0];
    for (var i = 0; i < faqContainers.length; i++) {
  
      faqContainers[i].addEventListener('click', function() {
  
        if (faqToggle.classList.contains('faq-display')) {
          faqToggle.classList.remove('faq-display');
          // alert("remove faq display!");
        } else {
          faqToggle.classList.add('faq-display');
          // alert("add faq display!");
        }
  
      });
    }
  }
  
  cardHeading (); 
  
  mathHeight('blog-articles','blog-articles__article','card__heading',2,1);
  mathHeight('blog-articles','blog-articles__article','article-card__excerpt',2,1);
  mathHeight('customer-stories-section','blog-articles','blog-articles__article','card__heading',2,1);
  mathHeight('customer-stories-section','blog-articles','blog-articles__article','article-card__excerpt',2,1);
  mathHeight('related-article-list','related-article-card_image','card__heading',2,1);
  mathHeight('related-article-list','related-article-card_image','article-card__excerpt',2,1);
  window.addEventListener("resize", cardHeading);

  ////// smooth scrolling
  if(document.querySelectorAll(".scrollToTopBtn") != null){
    var scrollToTopBtn = document.querySelectorAll(".scrollToTopBtn");
    var rootElement = document.documentElement;
  
    function scrollToTop() {
      // Scroll to top logic
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
    scrollToTopBtn.forEach( TopBtn=> {
      TopBtn.addEventListener("click", scrollToTop)
    });
  }

});

if($('.page--search-results-page').length > 0){
  $(document).on('Searchanise.ResultsUpdated', function(event, container) {
    var searchTitle = document.querySelectorAll(".snize-product .snize-title");
    var spanHeight = 0;
    searchTitle.forEach( snizTitle => {    
      var compareHeight = snizTitle.clientHeight;
      if( compareHeight > spanHeight ){
        spanHeight = snizTitle.clientHeight;
      }
    }); 
    searchTitle.forEach( snizHeight => {
      snizHeight.style.minHeight = spanHeight + "px";
    });
  });
  $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
    load_cart();
    document.querySelector('body').classList.add('open-drawer');
    document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
  });
}